class AuthService {
  login(payload) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}`, {
      credentials: 'same-origin',
      headers: {
        Authorization: `Basic ${btoa(
          `${payload.username.trim()}:${payload.password}`
        )}`
      },
      method: 'POST'
    })
  }
  getPerfis() {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/auth/Auth/listarpessoas`)
  }
  listContact(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/listarcontatos?username=${payload}`,
      { method: 'GET' }
    )
  }
  getContatos(login) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/contatos?login=${login}`,
      { method: 'GET' }
    )
  }
  recuperarSenha(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/recuperarsenha`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    )
  }
  redefinirSenha(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/redefinirsenha?code=${payload.code}`,
      {
        credentials: 'same-origin',
        headers: {
          Authorization: `Basic ${btoa(
            `${payload.username.trim()}:${payload.password}`
          )}`
        },
        method: 'POST'
      }
    )
  }
  alterarSenha(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/alterarsenha?code=${btoa(
        `${payload.code}`
      )}`,
      {
        credentials: 'same-origin',
        headers: {
          Authorization: `Basic ${btoa(
            `${payload.username.trim()}:${payload.password}`
          )}`
        },
        method: 'POST'
      }
    )
  }
  async contatosCpf(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/contatosCpf?cpf=${payload}`,
      {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      }
    )
  }
  async recuperarRegistro(emailTelefone, cpf) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/recuperarregistro?emailTelefone=${emailTelefone}` +
        (cpf?.length ? `&cpf=${cpf}` : ''),
      { method: 'POST' }
    )
  }
  atualizarSenha(payload) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/atualizarsenha?code=${btoa(
        `${payload.code}`
      )}`,
      {
        credentials: 'same-origin',
        headers: {
          Authorization: `Basic ${btoa(
            `${payload.username.trim()}:${payload.password}`
          )}`
        },
        method: 'POST'
      }
    )
  }
  codigoValido(codigo, letraUnidade) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/auth/Auth/codigovalido?unidade=${letraUnidade}`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: `"${codigo}"`
      }
    )
  }
  logout() {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/logout`, {
      method: 'POST'
    })
  }
}

export default new AuthService()
